export const classes = {
  wrapper: 'relative shrink-0 w-[62px] self-start ml-4 mt-[26px] mb-4',
  rail: 'group absolute left-0 top-0 z-40 hover:z-50 flex flex-col gap-2 w-[62px] hover:w-[212px] px-[9px] py-3 rounded-[22px] border border-white/[0.72] bg-rail-aurora shadow-aurora-card backdrop-blur-[12px] transition-[width] duration-200 ease-in-out',
};
